module.exports = __webpack_public_path__ + "static/media/p2.46f3ca0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/AdvisorsPartnersTeamResources/p2.svg
// module id = 232
// module chunks = 0